export const BOLETO = 2;
export const CREDIT_CARD = 5;
